import * as React from 'react';
import * as $ from 'jquery';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import * as ReactGA from 'react-ga';
import { getNoBrand } from '../../index';

//css
const footerStyle = require('./footer.css');


// Props
interface Props {
    loggedinUser: typeof LoggedinUser.Type;
}


@observer
export default class Footer extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

    trackOutboundLink = (url) => {
        ReactGA.event({
            category: 'OutboundLink',
            action: url,
        });
        return false;
    }

    render() {

        const callTo: string = 'tel:';
        const footerPhonenumber: string = callTo.concat(this.props.loggedinUser.branding.fullPhoneNumber);

        const mailTo: string = 'mailto:';
        const footerMailadress: string = mailTo.concat(this.props.loggedinUser.branding.mailAddress);

        const astyle = {
            color: '#FFFFFF',
        };

        //images
        //const branding = 'tellit';
        const branding = this.props.loggedinUser.branding.brandingName;
        const imgLogo = require('../../images/branding/' + branding + '/logo32x32.png');
        const noBrand = getNoBrand(); //generic brand

        
        if (noBrand) {
            // No brand
            return (
                <div>
                    <div className="footer_text_nourls">
                        <span>Mina sidor</span>
                    </div>
                </div>
            );
        } else if (!this.props.loggedinUser.view.allowUrls) {
        // We need to check that we allows Urls (when inApp Browser we do not allow Urls)
            // without Urls:
            return (
                <div>
                    <div className="footer_text_nourls">
                        <span style={astyle}><img src={imgLogo} alt="Mina sidor" title="Mina sidor" className="footer_logo" /></span><span>{this.props.loggedinUser.branding.displayName}</span>
                    </div>
                </div>
            );
        } else {
            // with Urls:
            return (
                <div>
                    <div className="footer_text">
                        {/* <a href="http://www.tellit.se" style={astyle}><span><img src={imgLogo} alt="Mina sidor" title="Mina sidor" className="footer_logo" /></span><span>Tellit</span></a> */}
                        <ReactGA.OutboundLink
                            eventLabel={this.props.loggedinUser.branding.displayName}
                            to={this.props.loggedinUser.branding.mainUrl}
                            target="_blank"
                            style={astyle}
                        >
                            <span><img src={imgLogo} alt="Mina sidor" title="Mina sidor" className="footer_logo" /></span>
                            <span>{this.props.loggedinUser.branding.displayName}</span>
                        </ReactGA.OutboundLink>


                        <span className="footer_text_2">
                            {/* <a href="tel:+46201202882" style={astyle}>Ring oss</a> */}
                            <ReactGA.OutboundLink
                                eventLabel="Ring oss"
                                to={footerPhonenumber}
                                target="_blank"
                                style={astyle}
                            >
                                Ring oss
                            </ReactGA.OutboundLink>

                            <span className="footer_text_3">
                                {/* <a href="mailto:kundsupport@tellit.se" style={astyle}>Maila oss</a></span> */}
                                <ReactGA.OutboundLink
                                    eventLabel="Maila oss"
                                    to={footerMailadress}
                                    target="_blank"
                                    style={astyle}
                                >
                                    Maila oss
                                </ReactGA.OutboundLink>
                            </span>

                        </span>
                    </div>
                </div>
            );
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/footer/Footer.tsx